export enum ESaveClipStep {
  CHECKING = "CHECKING",
  SUMMARY = "SUMMARY",
  SUCCESS = "SUCCESS",
  NO_STORAGE = "NO_STORAGE",
  DELETE_BROWSE = "DELETE_BROWSE",
  DELETE_CONFIRM = "DELETE_CONFIRM",
  ERROR = "ERROR",
}

export interface ISaveClipModalData {
  clipId: string;
  clipTitle: string;
}

export interface IStorageStatus {
  savedCount: number;
  limit: number;
  hasSpace: boolean;
}

export interface IClipForDeletion {
  id: string;
  internalId: string;
  title: string;
  thumbnailUrl: string;
  views: number;
  createdAt: string;
  saved?: {
    savedBy?: string[];
  };
}
